import { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';

import { Tooltip } from '@/shared/components/tooltip';

interface MapTooltipProps {
  posX: number;
  posY: number;
  areaName?: string;
  value?: number;
  valueColor: string;
  valueDecimalPlaces?: number;
}

const MapTooltip = ({
  posX,
  posY,
  areaName,
  value,
  valueColor,
  valueDecimalPlaces = 0,
}: MapTooltipProps) => {
  const formattedValue = useMemo(() => {
    if (value === undefined) {
      return 'N/A';
    }

    return new Intl.NumberFormat('en-US', {
      maximumFractionDigits: valueDecimalPlaces,
    }).format(value);
  }, [value, valueDecimalPlaces]);

  return (
    <Tooltip
      title={
        <>
          <Typography variant='body3'>{areaName ?? 'N/A'}</Typography>
          <Typography
            variant='body2'
            pt={0.5}
            fontWeight={600}
            color={valueColor}
          >
            {formattedValue}
          </Typography>
        </>
      }
      open={true}
      placement='top'
      sx={{ pointerEvents: 'none' }}
      slotProps={{
        popper: {
          disablePortal: true,
        },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: posX,
          top: posY,
          width: 0,
          height: 0,
        }}
      />
    </Tooltip>
  );
};

export default memo(MapTooltip);
